import React, { useContext, Fragment } from 'react';
import { Button, Text } from 'grommet';
import { withRouter } from 'react-router-dom';
import { withFirebaseConsumer } from 'components/common/Firebase';
import { AuthorizedUserContext } from 'components/common/AuthorizedUser';
import * as ROUTES from 'components/common/Routes';

// TODO: Consider to use GrommetThemeExtender or styled-components
const ButtonLabel = props => (
  <span style={{ whiteSpace: 'nowrap' }}>{props.children}</span>
);

const SignInOutButton = props => {
  const authorizedUser = useContext(AuthorizedUserContext);

  const signOut = async () => {
    await props.firebase.doSignOut();
    props.history.push(ROUTES.LANDING);
  };

  if (authorizedUser) {
    return (
      <Button
        fill={false}
        label={<ButtonLabel children={<Text color="brand">sign out</Text>} />}
        margin="xsmall"
        onClick={signOut}
      />
    );
  } else {
    return (
      <Fragment>
        <Button
          fill={false}
          label={
            <ButtonLabel
              children={
                <a href={ROUTES.AUTH}>
                  <Text color="brand">sign in</Text>
                </a>
              }
            />
          }
          margin="xsmall"
        />
        <Button
          fill={false}
          label={
            <ButtonLabel
              children={
                <a href={ROUTES.SIGN_UP}>
                  <Text color="light-1">try for free</Text>
                </a>
              }
            />
          }
          primary={true}
          margin="xsmall"
        />
      </Fragment>
    );
  }
};

export default withFirebaseConsumer(withRouter(SignInOutButton));
